module.exports = __webpack_public_path__ + "static/img/bg.0f349ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/login/bg.png
// module id = mQWx
// module chunks = 1